import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.67);
  backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  height: 75%;
  margin-bottom: ${(props: { isHorizontal: boolean }) => (props.isHorizontal ? '2%' : '10%')};
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  flex-grow: 1;
  background-color: white;
  border-radius: 10px;
  margin-bottom: ${(props: { isHorizontal: boolean }) => (props.isHorizontal ? '2%' : '10%')};
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 100rem;
  background-color: white;
`;

export const IFrame = styled.iframe`
  border-radius: 10px;
  width: 100%;
  height: 100%;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props: { show: boolean }) => (props.show ? 'block' : 'none')};
`;
